import { useStores } from '@littlebird/sdk';
import {
  getResumeConfirmation,
  ROUTINE_AUTO_PAUSE_RESUME_CONFIRMATION,
} from '@littlebird/ui-utils';

import { ConfirmDialog } from '@/components/modals/ConfirmationModal';
import { ModalsManager } from '@/components/modals/modalsManager';

export const useResumeRoutine = () => {
  const { routines } = useStores();

  return async (routineId: number) => {
    const routine = routines.getByReferenceId(routineId);
    if (routine?.isAdminPaused) return;

    const confirmation = routine
      ? getResumeConfirmation(routine)
      : ROUTINE_AUTO_PAUSE_RESUME_CONFIRMATION;

    if (confirmation) {
      const confirmed = await ModalsManager.showResolvable(ConfirmDialog, {
        ...confirmation,
        confirmVariant: 'default',
      });
      if (!confirmed) return;
    }

    // The store rolls back and logs; no screen surfaces a failed resume.
    await routines.unpauseRoutine(routineId).catch(() => undefined);
  };
};
